import parse from 'html-react-parser';
import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useSafeState } from 'hooks';
import { routes } from 'router';

const PaymentForm = () => {
  const { t } = useTranslation();
  const isTravelRoute = useMemo(() => {
    const travelRoutes = routes.travelPurchase.path;
    return location.pathname.includes(travelRoutes);
  }, [location.pathname]);

  const { showCart } = useSelector((state) => state.cart);

  const storedPaymentBody = useSelector((state) =>
    isTravelRoute ? state.travelPurchase.paymentBody : state.leisurePurchase.paymentBody
  );
  const storedPaymentHead = useSelector((state) =>
    isTravelRoute ? state.travelPurchase.paymentHead : state.leisurePurchase.paymentHead
  );
  const [scriptContent, setScriptContent] = useSafeState('');
  const [linkContent, setLinkContent] = useSafeState('');

  useEffect(() => {
    const { scriptContent, linkContent } = searchScriptContent(storedPaymentHead) || {};
    scriptContent && setScriptContent(scriptContent);
    linkContent && setLinkContent(linkContent);
  }, [storedPaymentHead]);

  useEffect(() => {
    /**
     * This is a workaround to reload the page when the form is ready.
     * This is needed because the form is not visible if we go back to a previous step and then go forward again.
     * See Payzen documentation https://payzen.io/fr-FR/rest/V4.0/javascript/redirection/presentation_methods.html
     */
    window.KR?.onFormReady(() => {
      !showCart && window.location.reload();
    });
  }, []);

  const searchScriptContent = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const scriptElement = doc.querySelector('script[src^="https://static.payzen.eu"]');
    const linkElement = doc.querySelector('link[href^="https://static.payzen.eu"]');

    if (scriptElement && linkElement) {
      return {
        scriptContent: scriptElement.outerHTML,
        linkContent: linkElement.outerHTML
      };
    }
  };
  return (
    <div>
      <Helmet>
        {scriptContent && parse(scriptContent)}
        {linkContent && parse(linkContent)}
      </Helmet>
      <h2 className="hidden underlined-blue lg:mb-8 lg:block lg:h2">{t('purchase:payment.title')}</h2>

      {storedPaymentBody && parse(storedPaymentBody)}
    </div>
  );
};

export default PaymentForm;
